// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-gallery{margin-top:60px}.video-gallery h2{margin-bottom:30px}.video-gallery .video{height:100%}@media screen and (max-width:991px){.video-gallery .videos__list{display:none}}", ""]);
// Exports
module.exports = exports;
